import _ from "lodash";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Reports from "../../common/reports/Reports";
import Autocomplete from "../../framework/Autocomplete";
import Button from "../../framework/Button";
import GlobalContext from "../../framework/GlobalContext";
import Shortcut from "../../framework/Shortcut";
import classes from "./index.module.css";
import BranchGroupFilter from "./BranchGroupFilter";
import BranchGroupSummary from "./BranchGroupSummary";
import AddBranchGroup from "./addBranchGroup/index";

const BranchGroup = () => {
  const [showAddBranchGroup, setShowAddBranchGroup] = useState(false);
  const [branchGroupData, setBranchGroupData] = useState(null);
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const [rowLevelCTAs, setRowLevelCTAs] = useState([]);
  const [filterStates, setFilterStates] = useState(null);
  const [refreshData, setRefreshData] = useState(false);
  const [filterParams, setFilterParams] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);
  const { setCurrentComponent, currentComponent } = useContext(GlobalContext);
  const reportRef = useRef();
  const editRef = useRef();
  const refreshRef = useRef();

  const addBranchGroup = useCallback((isEdit = false) => {
    if (isEdit) {
      const data = reportRef.current.getCurrentRowData();
      setBranchGroupData(data);
    }
    setShowAddBranchGroup(true);
  }, []);

  const closeBranchGroupAc = useCallback(() => {
    setShowAddBranchGroup(false);
    setBranchGroupData(null);
    setCurrentComponent("grid_reports");
  }, [setCurrentComponent]);

  const debounceCloseBranchGroupAc = _.debounce(closeBranchGroupAc, 200);

  const listener = useCallback(
    (e) => {
      const key = e.key?.toLowerCase();
      const ctrlKey = e.ctrlKey;
      const altKey = e.altKey;
      if (altKey && key === "r") {
        setRefreshData(true);
        return;
      }
      if (ctrlKey && key === "e") {
        if (currentRowData) return editRef.current.click();
      }
      if (altKey && key === "b") {
        return addBranchGroup();
      }
    },
    [addBranchGroup, currentRowData]
  );

  const applyFilterHandler = useCallback((params, filterStates) => {
    setRefreshData(false);
    setFilterParams(params);
    setFilterStates(filterStates);
  }, []);

  useEffect(() => {
    const allRowCTAs = [
      <Button
        ref={editRef}
        startIcon={<Shortcut keys={["Ctrl", "E"]} />}
        label="Edit"
        onClick={() => {
          addBranchGroup(true);
        }}
        isAccessible={currentRowData}
      />,
    ];
    setRowLevelCTAs(allRowCTAs);
  }, [addBranchGroup, currentRowData]);
  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);
    }
  }, [refreshData]);
  useEffect(() => {
    if (
      !onFilterShow &&
      !showAddBranchGroup &&
      !onColumnShow &&
      currentComponent === "grid_reports"
    ) {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [
    currentComponent,
    listener,
    onColumnShow,
    onFilterShow,
    showAddBranchGroup,
  ]);
  return (
    <div className={classes["branch-grp-report-container"]}>
      <Reports
        identifier="branchGroup"
        reportRef={reportRef}
        rowLevelCTAs={rowLevelCTAs}
        filterStates={filterStates}
        filterParams={filterParams}
        onFilterShowClick={setOnFilterShow}
        onColumnShowClick={setOnColumnShow}
        filters={
          <BranchGroupFilter
            reportRef={reportRef}
            filters={(filters) => {
              setFilterStates(filters);
            }}
            refreshData={refreshData}
            onFilterShow={onFilterShow}
            applyFilters={applyFilterHandler}
          />
        }
        currentRow={(data) => {
          setCurrentRowData(data);
        }}
      />
      <BranchGroupSummary
        refreshData={() => {
          setRefreshData(true);
        }}
        refreshRef={refreshRef}
        showAutoComplete={() => {
          addBranchGroup();
        }}
      />
      <Autocomplete
        show={showAddBranchGroup}
        height="50%"
        width="50%"
        closeAutoComplete={debounceCloseBranchGroupAc}
      >
        <AddBranchGroup
          branchData={branchGroupData}
          onEscape={debounceCloseBranchGroupAc}
          onSaveBranch={() => {
            debounceCloseBranchGroupAc();
            setRefreshData(true);
          }}
        />
      </Autocomplete>
    </div>
  );
};

export default BranchGroup;
